export type AddChildState = {
  nickname: string;
  birthYear: string;
  schoolGrade: string;
  isSubmitting: boolean;
  error: string | null;
};

const asInteger = (value: string): number | null => {
  const parsed = Number(value);

  return /^\d+$/.test(value.trim()) && Number.isInteger(parsed) ? parsed : null;
};

export const canSubmit = (state: AddChildState): boolean =>
  !state.isSubmitting &&
  state.nickname.trim().length > 0 &&
  asInteger(state.birthYear) !== null &&
  asInteger(state.schoolGrade) !== null;

export const readInteger = asInteger;
